import React from 'react';
import Icon from '../Icon';
import {generateCawiUrl} from '../../utils/urls';

const CawiLink = ({disabled, id}) => (
    <a href={disabled ? undefined : generateCawiUrl(id)} target="_blank" rel="noopener noreferrer" className={disabled ? 'disabled' : undefined}>
        <Icon icon="view" />
    </a>
);

export default CawiLink;
